import type { AjaxObject } from "@rootreeweb/plugin-lib";

/** This object is passed in when WordPress localizes the script. */

declare const rttsml_RT_TSML_Testimonial_ajax_obj: AjaxObject;

if (
	document.getElementById(
		rttsml_RT_TSML_Testimonial_ajax_obj.selectorPrefix + "-create",
	)
) {
	void import("@rootreeweb/plugin-lib").then(
		(e) => new e.Admin(rttsml_RT_TSML_Testimonial_ajax_obj),
	);
}

declare const rttsml_RT_TSML_Category_ajax_obj: AjaxObject;

if (
	document.getElementById(
		rttsml_RT_TSML_Category_ajax_obj.selectorPrefix + "-create",
	)
) {
	void import("@rootreeweb/plugin-lib").then(
		(e) => new e.Admin(rttsml_RT_TSML_Category_ajax_obj),
	);
}
